import { QUANTUM_UI } from '../../../flags';
import { Title as TitleNew } from './Title';
import { Title as TitleOld } from './Title.old';
export var Title = QUANTUM_UI ? TitleNew : TitleOld;
export * from './titleStyles';
